//import Libraries
import React from 'react';
import {connect} from 'react-redux';
import {Table} from 'reactstrap';

//import Components
import CartItem from './CartItem';

import Language from '../../../language/language.json'

//import Styles

const cartList = ({cart, products, universal}) => {
    if(cart.length === 0) {
        
        return (
            <div>
            </div>
            );
    } 

    const {language} = universal;

    return(
        <Table>
            <thead>
                <tr className="cartRow">
                    <td>{Language.cart.name[language]}</td>
                    <td>{Language.cart.type[language]}</td>
                    <td>{Language.cart.quantity[language]}</td>
                    <td>{Language.cart.delete[language]}</td>
                </tr>
            </thead>
            <tbody>
            {
                    cart.map((item, index) => {
                    const productIndex = products.findIndex((product) => {
                        return item.id === product.id;
                    })
                    if(productIndex !== -1){
                        const product = products[productIndex];
                        const type = product.types ? product.types[item.typeIndex] : null;
                        return(
                            <CartItem 
                                id={item.id}
                                name={product.name} 
                                type={type}
                                typeIndex={item.typeIndex}
                                quantity={item.quantity} 
                                index={index}
                                key={`${item.id}-${item.typeIndex}`} 
                                universal={universal}
                            />
                        );
                    }
                })
            }
            </tbody>
        </Table>
    )
}

export default cartList;


// WEBPACK FOOTER //
// ./src/pages/Store/Cart/CartList.js